import * as React from 'react';
import {ICustomEditorButtonsSettings} from "../tron-editor-interfaces";
import {EditorButtonsFunctions} from "../../../shared/logo.types";

export interface ICustomLogoEditorPreviewControlsProps {
    settings: ICustomEditorButtonsSettings;
    executeBtnFunction(btnFunction: EditorButtonsFunctions): void;
}

export class CustomLogoEditorPreviewControls extends React.Component<ICustomLogoEditorPreviewControlsProps> {
    constructor(props: ICustomLogoEditorPreviewControlsProps) {
        super(props);
    }

    private getStyleObjectFromString(strStyle: string) {
        const style = {};
        strStyle.split(";").forEach(el => {
            const [property, value] = el.split(":");
            if (!property) { return; }

            const formattedProperty = this.formatStringToCamelCase(property.trim());
            style[formattedProperty] = value.trim();
        });

        return style;
    };

    private formatStringToCamelCase(str: string) {
        const splitted = str.split("-");
        if (splitted.length === 1) {return splitted[0]};
        return (
            splitted[0] +
            splitted
                .slice(1)
                .map(word => word[0].toUpperCase() + word.slice(1))
                .join("")
        );
    };

    private getBtn1() {
        if (!this.props.settings.button1Enabled) {return undefined;}
        return (<div className="editor-preview-btn">
            <button style={this.getStyleObjectFromString(this.props.settings.button1Css)}
                    onClick={() => this.props.executeBtnFunction(this.props.settings.button1Function)}>
                <div className="icon-btn-content">
                    <div className="text-content-custom">
                        <span>{this.props.settings.button1Label}</span>
                    </div>
                </div>
            </button>
        </div>);
    }

    private getBtn2() {
        if (!this.props.settings.button2Enabled) {return undefined;}
        return (<div className="editor-preview-btn">
            <button style={this.getStyleObjectFromString(this.props.settings.button2Css)}
                    onClick={() => this.props.executeBtnFunction(this.props.settings.button2Function)}>
                <div className="icon-btn-content">
                    <div className="text-content-custom">
                        <span>{this.props.settings.button2Label}</span>
                    </div>
                </div>
            </button>
        </div>);
    }

    public render() {
        return (
            <div className="editor-preview-controls">
                {this.getBtn1()}
                {this.getBtn2()}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App/logo-app/logo-editor/logo-editor-controls/custom-preview-controls.component.tsx